import React from "react";

export function FormControlStyles({ theme = "dark" }: { theme?: "dark" | "light" }) {
  const isDark = theme === "dark";

  const selectColorScheme = isDark ? "dark" : "light";
  const optionBg = isDark ? "rgba(10, 12, 36, 0.98)" : "#ffffff";
  const optionText = isDark ? "rgba(255, 255, 255, 0.82)" : "#0f172a";
  const optionDisabledText = isDark ? "rgba(255, 255, 255, 0.35)" : "rgba(15, 23, 42, 0.45)";

  return (
    <style>{`
      /* Ensure native form controls prefer the page theme where supported */
      .kq-select{ color-scheme: ${selectColorScheme}; }

      /* Dropdown list (options) */
      .kq-select option{
        background-color: ${optionBg};
        color: ${optionText};
      }
      .kq-select option:disabled{
        color: ${optionDisabledText};
      }
    `}</style>
  );
}
